import "./BulkReportGenerationIndicator.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { useState } from "react";

import { RemoveTaskMessage } from "shared/actions/webSocketMessageActions";
import {
  SocketData,
  SocketStatus,
} from "shared/reducers/webSocketMessageReducer";
import {
  SUPPORT_EMAIL,
  SUPPORT_EMAIL_MAILTO,
} from "shared/utils/siteConstants";

import Spinner from "components/Spinner";
import { useAppDispatch, useAppSelector } from "store/hooks";

const TaskListItem = ({
  task,
  onClearTask,
}: {
  task: SocketData;
  onClearTask: Function;
}) => {
  const [visibleDetails, setVisibleDetails] = useState<boolean>(false);
  return (
    <div className="ReportGeneratorTask">
      {task.status === SocketStatus.INITIALIZED ? (
        <span>
          <Spinner size="1em" /> Generating bulk report zipfile
        </span>
      ) : task.status === SocketStatus.SUCCESS ? (
        <>
          <FontAwesomeIcon
            icon="times"
            cursor="pointer"
            onClick={() => onClearTask(task.details?.task_id)}
          />
          <div className="ReportGeneratorTask__content">
            <a href={task.details?.archive_url}>
              Download report zipfile <FontAwesomeIcon icon="file-download" />
            </a>
            {!!task.details?.failed_reports?.length && (
              <div
                className="ReportGeneratorTask__layout--vertical"
                onClick={() => setVisibleDetails(!visibleDetails)}
              >
                <span className="ReportGeneratorTask--error">
                  {task.details.failed_reports.length} Report
                  {task.details.failed_reports.length === 1 ? "" : "s"} could
                  not be included <FontAwesomeIcon icon="angle-down" />
                </span>
                {visibleDetails && (
                  <div className="ReportGeneratorTask__layout--vertical">
                    {task.details.failed_reports.map(
                      (d: { accession: string; id: number }) => (
                        <span>{d.accession}</span>
                      )
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </>
      ) : (
        task.status === SocketStatus.FAILED && (
          <>
            <FontAwesomeIcon
              icon="times"
              cursor="pointer"
              onClick={() => onClearTask(task.details?.task_id)}
            />
            <div
              onClick={() => setVisibleDetails(!visibleDetails)}
              className="ReportGeneratorTask__content"
            >
              <span className="ReportGeneratorTask--error">
                Failed to generate zipfile <FontAwesomeIcon icon="angle-down" />
              </span>
              {visibleDetails && (
                <div>
                  <p className="ReportGeneratorTask--error">
                    {task.details?.error_message}
                  </p>
                  <span>
                    Please contact support{" "}
                    <a href={SUPPORT_EMAIL_MAILTO}>{SUPPORT_EMAIL}</a>
                  </span>
                </div>
              )}
            </div>
          </>
        )
      )}
    </div>
  );
};

const BulkReportGenerationIndicator = () => {
  const [minimizedIndicator, setMinimizedIndicator] = useState<boolean>(false);
  const { data: tasks } = useAppSelector((state) => state.webSocketMessages);
  const dispatch = useAppDispatch();

  const onClearTask = (task_id: string) => {
    dispatch(RemoveTaskMessage(task_id));
  };

  return !!tasks.length ? (
    <div className="ReportGenerator">
      <span
        className="ReportGenerator__minimizer"
        onClick={() => {
          setMinimizedIndicator(!minimizedIndicator);
        }}
      >
        <FontAwesomeIcon icon="bars" />
      </span>
      <div
        className={classNames("ReportGenerator__content", {
          ReportGenerator__minimized: minimizedIndicator,
        })}
      >
        {tasks.map((t) => (
          <TaskListItem
            task={t}
            key={t.details?.task_id}
            onClearTask={onClearTask}
          />
        ))}
      </div>
    </div>
  ) : null;
};

export default BulkReportGenerationIndicator;
